module.exports = __webpack_public_path__ + "media/fonts/Oricons-6a8064bfbaa4b02bbfb1da29ca188729.svg";